import { render, staticRenderFns } from "./WidgetStatChart.vue?vue&type=template&id=c3b4893c&scoped=true"
import script from "./WidgetStatChart.vue?vue&type=script&lang=js"
export * from "./WidgetStatChart.vue?vue&type=script&lang=js"
import style0 from "./WidgetStatChart.vue?vue&type=style&index=0&id=c3b4893c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b4893c",
  null
  
)

export default component.exports